<template>
    <div class="system">
        <div class="tab">
            <div class="tabLi" v-for="(item, index) in categoryThird" :key="item.id" v-show="index < 7" @click="goThird(item, index)">
                <div class="img"><img v-lazy="item.imgUrl + '?x-oss-process=image/resize,m_pad,h_400,w_400/quality,Q_100'" alt="类目"></div>
                <span v-text="item.name"></span>
            </div>
            <div class="tabLi" @click="onMore">
                <div class="img"><img src="../../../../assets/img/b2b/icon_more@2x.png" alt=""></div>
                <span>查看更多</span>
            </div>
        </div>
        <div class="nav">
            <span :class="{'active' : isNavList}" @click="changeFaddish()">爆款</span>
        </div>
        <div ref="searchBar">
            <GoodsList ref="goodsList" isType="isType" :categoryId='item.id' screenType='2'></GoodsList>
        </div>
        <div class="homeBottom"></div>
    </div>
</template>
<script>
import GoodsList from '../../goods/common/navTab'
export default {
    name: 'system',
    components: {
        GoodsList
    },
    props: {
        tab: Number,
        item: {
            type: Object,
            required: false,
            default () {
                return {}
            }
        }
    },
    computed: {
        categoryThird () {
            const temp = []
            if (this.item.subCategoryList) {
                this.item.subCategoryList.forEach(value => value.subCategoryList.forEach(value1 => temp.push(value1)))
            }
            return temp
        }
    },
    data () {
        return {
            isNavList: false,
            navList: [{ value: '爆款', id: 'faddish' }],
            merchantCode: '',
            memberCode: '',
            brandId: '',
            categoryId: '',
            faddish: ''
        }
    },
    methods: {
        goThird (item, index) {
            localStorage.setItem('goodsListBack', this.$router.history.current.fullPath)
            this.$router.push({
                path: '/b2b/goods/goodsList',
                query: {
                    id: item.id,
                    name: item.categoryName,
                    screenType: 2
                }
            })
        },
        changeFaddish () {
            this.isNavList = !this.isNavList
            let faddish = this.isNavList ? '1' : ''
            this.$refs.goodsList.onFaddish(faddish)
        },
        onMore () {
            this.$router.push({ path: '/b2b/goods/allGoods2', query: { ctIndex: this.tab } })
        },
        init () {
            this.$refs.goodsList.onSubmit()
        }
    },
    mounted () {
        localStorage.setItem('tab', this.tab)
        let userInfo = JSON.parse(localStorage.getItem('userInfo'))
        this.merchantCode = userInfo.belongMerchantCode
        this.memberCode = userInfo.companyCode
        this.$refs.goodsList.onSubmit()
    }
}
</script>
<style lang="scss" scoped>
    .isFixed {
        position: fixed !important;
        z-index: 999;
    }
    .system {
        width: 100%;
        .tab {
            display: flex;
            flex-wrap: wrap;
            justify-content: flex-start;
            padding: 0 24px;
            .tabLi {
                flex: 0 0 25%;
                margin-top: 30px;
                text-align: center;
                font-size: 28px;
                color: #333333;
                .img {
                    width: 100px;
                    height: 100px;
                    border-radius: 50%;
                    margin: 0 auto;
                    overflow: hidden;
                    position: relative;
                    background: #ffffff;
                    img {
                        max-width: 50%;
                        max-height: 50%;
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%)
                    }
                }
                span {
                    margin-top: 10px;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 1;
                    overflow: hidden;
                    white-space: normal;
                    word-break: break-all;
                }
            }
        }
        .nav {
            margin-top: 40px;
            margin-bottom: 20px;
            padding: 0 24px;
            font-size: 28px;
            display: flex;
            justify-content: space-between;
            span {
                display: inline-block;
                width: 140px;
                height: 56px;
                line-height: 56px;
                border-radius: 56px;
                text-align: center;
                color: #666666;
                background: #EAEAEA;
                &.active {
                    background: #FF7D4A;
                    color: #ffffff;
                }
            }
        }
    }
</style>
